internalSplit